import { triggerEvent } from 'utilities/dom';

/**
 *
 * Track full screen image changes
 * @param {string} sku
 * @param {string} imagePath
 * @param {obj} trackingObj (optional)
 * @returns void
 */
function trackFullScreenImage (sku, imagePath, trackingObj = {}) {

	if (!sku) {

		return;

	}

	if (!imagePath || typeof imagePath !== 'string') {

		return;

	}

	triggerEvent.call(document, 'product:fullscreen:image', {
		event_category: 'PDP',
		event_action: 'Click-Thumbnail-Image-Modal',
		event_label: `${sku}-${imagePath.replace(/^(cropped|views|scenes)\//gi, '')}`,
		...trackingObj
	});

}

export default trackFullScreenImage;
